import AccessGuardLayout from '~/components/layouts/AccessGuardLayout';
import Conversion from '~/images/planGates/increase_conversion_rates.svg';
import Autofill from '~/images/planGates/qualify_leads.svg';
import Tile from '~/images/Tiles/Forms.svg';
import history from '~/lib/history';
import paths from '~/lib/paths';

export default function FormsAccess() {
  return (
    <AccessGuardLayout
      description="Capture more qualified leads by shortening your forms without losing the data you need to qualify, route, and sell."
      featureCallouts={[
        {
          name: 'Increase conversion rates',
          description:
            'Shorten your forms by hiding fields that Clearbit enriches. Ensure 100% data capture by dynamically displaying critical fields when Clearbit can’t fill them in.',
          image: <Conversion />,
        },
        {
          name: 'Accurately qualify and route leads',
          description:
            'Reduce qualification and routing errors caused by fake answers on your forms. Enrich emails in real time with high-quality, externally verified data.',
          image: <Autofill />,
        },
      ]}
      onRequestAccess={() => {
        history.push(paths.formsAccessRequest());
      }}
      testimonial={{
        quote: "Without Clearbit, we'd be missing out on leads every month",
        customerName: 'Giles Bertaux',
        customerTitle: 'Co-founder & CEO at Livestorm',
        url: 'https://clearbit.com/customers/livestorm',
      }}
      tile={<Tile />}
      title="Forms"
    />
  );
}
